import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a99ef6ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-filter" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"2"} }, "启用滤镜：", -1))
const _hoisted_4 = {
  class: "switch-wrapper",
  style: {"flex":"3"}
}
const _hoisted_5 = {
  key: 0,
  class: "filter"
}
const _hoisted_6 = { class: "name" }

import { ref, watch } from 'vue'
import { storeToRefs } from 'pinia'
import { useMainStore, useSlidesStore } from '@/store'
import { PPTImageElement } from '@/types/slides'
import useHistorySnapshot from '@/hooks/useHistorySnapshot'

import { Slider, Switch } from 'ant-design-vue'

interface FilterOption {
  label: string
  key: string
  default: number
  value: number
  unit: string
  max: number
  step: number
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ElementFilter',
  setup(__props) {

const defaultFilters: FilterOption[] = [
  { label: '模糊', key: 'blur', default: 0, value: 0, unit: 'px', max: 10, step: 1 },
  { label: '亮度', key: 'brightness', default: 100, value: 100, unit: '%', max: 200, step: 5 },
  { label: '对比度', key: 'contrast', default: 100, value: 100, unit: '%', max: 200, step: 5 },
  { label: '灰度', key: 'grayscale', default: 0, value: 0, unit: '%', max: 100, step: 5 },
  { label: '饱和度', key: 'saturate', default: 100, value: 100, unit: '%', max: 200, step: 5 },
  { label: '色相', key: 'hue-rotate', default: 0, value: 0, unit: 'deg', max: 360, step: 10 },
  { label: '不透明度', key: 'opacity', default: 100, value: 100, unit: '%', max: 100, step: 5 },
]

const slidesStore = useSlidesStore()
const { handleElement, handleElementId } = storeToRefs(useMainStore())

const filterOptions = ref<FilterOption[]>(JSON.parse(JSON.stringify(defaultFilters)))
const hasFilters = ref(false)

const { addHistorySnapshot } = useHistorySnapshot()

watch(handleElement, () => {
  if (!handleElement.value || handleElement.value.type !== 'image') return
  
  const filters = handleElement.value.filters
  if (filters) {
    filterOptions.value = defaultFilters.map(item => {
      if (filters[item.key] !== undefined) return { ...item, value: parseInt(filters[item.key]) }
      return item
    })
    hasFilters.value = true
  }
  else {
    filterOptions.value = JSON.parse(JSON.stringify(defaultFilters))
    hasFilters.value = false
  }
}, { deep: true, immediate: true })

// 设置滤镜
const updateFilter = (filter: FilterOption, value: number) => {
  const _handleElement = handleElement.value as PPTImageElement
  
  const originFilters = _handleElement.filters || {}
  const filters = { ...originFilters, [filter.key]: `${value}${filter.unit}` }
  slidesStore.updateElement({ id: handleElementId.value, props: { filters } })
  addHistorySnapshot()
}

const toggleFilters = (checked: boolean) => {
  if (!handleElement.value) return
  if (checked) {
    slidesStore.updateElement({ id: handleElement.value.id, props: { filters: {} } })
  }
  else {
    slidesStore.removeElementProps({ id: handleElement.value.id, propName: 'filters' })
  }
  addHistorySnapshot()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_unref(Switch), {
          checked: hasFilters.value,
          onChange: _cache[0] || (_cache[0] = checked => toggleFilters(checked as boolean))
        }, null, 8, ["checked"])
      ])
    ]),
    (hasFilters.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filterOptions.value, (filter) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "filter-item",
              key: filter.key
            }, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(filter.label), 1),
              _createVNode(_unref(Slider), {
                class: "filter-slider",
                max: filter.max,
                min: 0,
                step: filter.step,
                value: filter.value,
                onChange: value => updateFilter(filter, value as number)
              }, null, 8, ["max", "step", "value", "onChange"])
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})